import { render, staticRenderFns } from "./Stages.vue?vue&type=template&id=52ee477f&scoped=true&"
import script from "./Stages.vue?vue&type=script&lang=js&"
export * from "./Stages.vue?vue&type=script&lang=js&"
import style0 from "./Stages.vue?vue&type=style&index=0&id=52ee477f&lang=scss&scoped=true&"
import style1 from "./Stages.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ee477f",
  null
  
)

export default component.exports